module.exports = __webpack_public_path__ + "static/img/3求是创新.924c9dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/3求是创新.png
// module id = rQPp
// module chunks = 0